import { jsx } from "react/jsx-runtime";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { validateTidalLicense } from "../../base/index.js";
function Lightbulb(props) {
  return /* @__PURE__ */ jsx(
    LightbulbIcon,
    {
      "data-testid": "Lightbulb",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Lightbulb",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Lightbulb.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Lightbulb"
};
validateTidalLicense();
export {
  Lightbulb
};
//# sourceMappingURL=Lightbulb.js.map
